import { memo, useEffect, useRef } from 'react';

const FooterClone = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const innerFooter = containerRef.current?.querySelector('footer');
    if (!innerFooter) {
      const realFooter = document.querySelector('footer');
      if (realFooter) {
        containerRef.current?.appendChild(realFooter.cloneNode(true));
      }
    }
  });
  return <div ref={containerRef} />;
};

export default memo(FooterClone);
